import { motion, useReducedMotion } from "framer-motion";
import { pageVariants } from "./variants";

const PageTransition = ({ children }) => {
	const shouldReduceMotion = useReducedMotion();

	if (shouldReduceMotion) {
		return <>{children}</>;
	}

	return (
		<motion.div
			className="page-transition"
			variants={pageVariants}
			initial="initial"
			animate="animate"
			exit="exit"
		>
			{children}
		</motion.div>
	);
};

export default PageTransition;
